function createNumberArray(size) {
  const array = [];
  for (let i = 0; i < size; i++) {
    array.push(i);
  }
  return array;
}

export default function TemplateCardList({ size = 4 }) {
  const loadingMockArray = createNumberArray(size);
  return (
    <div className="grid grid-cols-1 gap-4 pb-8 pt-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {loadingMockArray.map((i) => (
        <div
          key={i}
          className="animate-pulse rounded-xl border border-gray-200 bg-white py-4 pl-4 pr-2 shadow-sm"
        >
          <div className="flex gap-4">
            <div className="h-16 w-16 shrink-0 rounded-xl bg-gray-200" />
            <div className="min-w-0 flex-grow">
              <div className="mb-2 h-4 w-3/4 rounded-full bg-gray-200" />
              <div className="h-2.5 w-1/2 rounded-full bg-gray-200" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
